
import { AssetMaintenanceRowsEntityDecorator } from './asset-maintenance-rows.decorator';
import { AssetMaintenanceRowsTypeInfoBase } from './asset-maintenance-rows.typeinfo.base';
import { AssetMaintenanceTypeInfo } from './asset-maintenance.typeinfo';


export class AssetMaintenanceRowsTypeInfo extends AssetMaintenanceRowsTypeInfoBase<any> {
  constructor() {
    super(new AssetMaintenanceTypeInfo(), new AssetMaintenanceRowsEntityDecorator());
  }
}

export const ASSET_MAINTENANCE_ROWS_TYPE: AssetMaintenanceRowsTypeInfo = new AssetMaintenanceRowsTypeInfo();



